<div class="filter">
  <div class="filter__wrapper">
    <input
      #input
      name="search"
      placeholder="Search..."
      autocomplete="off"
      (ngModelChange)="onSearchTextChange($event)"
      [ngModel]="text"
      class="filter__search"
    />
  </div>
  <div class="filter__options">
    <div class="filter__option" *ngIf="(searchText$ | async) === ''">
      <input
        class="filter__checkbox"
        type="checkbox"
        value="All"
        (change)="onAllCheckboxChange($event.target.checked)"
        [checked]="isAllChecked$ | async"
      />
      <label class="filter__label">All</label>
    </div>
    <div class="filter__option" *ngFor="let value of values$ | async">
      <div class="filter__option" *ngIf="doesPartialMatchPass(value) | async">
        <input
          class="filter__checkbox"
          type="checkbox"
          value="{{ value }}"
          (change)="onCheckboxChange($event.target.value, $event.target.checked)"
          [checked]="isCheckboxChecked(value) | async"
        />
        <label class="filter__label">{{ value }}</label>
      </div>
    </div>
  </div>
</div>
